import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLID,
  GraphQLBoolean
} from 'graphql'
import { organizationDigestSettingsType } from '../types/organization-digest-settings'
import { Context } from '../shared'

interface OrganizationDigestSettingsArgs {
  readonly organizationID: string
  readonly compliance: boolean
  readonly remediation: boolean
  readonly library: boolean
}

interface OrganizationDigestSettings {
  readonly id: string
  readonly compliance: boolean
  readonly remediation: boolean
  readonly library: boolean
}

interface UpdateOrganizationDigestSettingsMutationArgs {
  readonly input: OrganizationDigestSettingsArgs
}

const updateOrganizationDigestSettingsArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'UpdateOrganizationDigestSettingsArg',
      description:
        "Mutation input type for updating an organization's digest settings",
      fields: () => ({
        organizationID: {
          description: 'The ID of the organization',
          type: new GraphQLNonNull(GraphQLID)
        },
        compliance: {
          description: 'Is compliance policy violation digest enabled',
          type: new GraphQLNonNull(GraphQLBoolean)
        },
        remediation: {
          description: 'Is remediation policy violation digest enabled',
          type: new GraphQLNonNull(GraphQLBoolean)
        },
        library: {
          description: 'Is library policy violation digest enabled',
          type: new GraphQLNonNull(GraphQLBoolean)
        }
      })
    })
  }
}

export const updateOrganizationDigestSettings: GraphQLFieldConfig<
  any,
  Context,
  UpdateOrganizationDigestSettingsMutationArgs
> = {
  description: "Update an organization's digest settings",
  type: new GraphQLNonNull(organizationDigestSettingsType),
  args: updateOrganizationDigestSettingsArgs,
  resolve: async (
    _source,
    args,
    context
  ): Promise<OrganizationDigestSettings> => {
    if (!args.input) {
      throw new Error('mutation input parameter is required')
    }

    const { organizationID, compliance, remediation, library } = args.input

    await context.connector.put(
      `${organizationID}/notifications/digest/organization`,
      {
        digest_compliance: compliance,
        digest_remediation: remediation,
        digest_library: library
      }
    )

    return {
      id: organizationID,
      compliance,
      remediation,
      library
    }
  }
}
